// A FEW STRAY ELEMENTS MUST NOT DECIDE WHERE THE CAMERA AND THE SKY GO
// (owner 2026-10-19, SpaceX BA03 blank and its sky in pieces). The export
// published 16:10Z puts 5 elements from imported DWGs (civil, xBase, KHA,
// mechanical) in one outlier tile reaching 9,058,112,660 ft up. The loader
// framed the camera and sized the sky dome to fullBounds whenever an
// outlier tile held anything, so the camera sat billions of feet out
// (nothing drawn, nothing fetched) and the dome was too big for the depth
// buffer. A real far link (BA03's terrain, ~10,000 ft beside a 2,800 ft
// building) is a few times the main cluster; a stray is millions of times.

// fullBounds counts as reach only within this many main-cluster sizes.
export const MAX_REACH = 50;

const diag = (b) => {
  if (!b || !b.min || !b.max) return 0;
  const d = [0, 1, 2].map((i) => Number(b.max[i]) - Number(b.min[i]));
  if (d.some((x) => !Number.isFinite(x))) return Infinity;
  return Math.hypot(d[0], d[1], d[2]);
};

// True when the manifest's fullBounds is far beyond its trimmedBounds:
// the outliers are strays, and framing and the sky use the main cluster.
export function fullBoundsAreStray(scene) {
  const full = diag(scene && scene.fullBounds);
  const trimmed = diag(scene && scene.trimmedBounds);
  if (!full || !trimmed) return false;
  return full > trimmed * MAX_REACH;
}
